import script from "./InternetConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./InternetConfigure.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__